import { render, staticRenderFns } from "./regulDbUploadHistory.vue?vue&type=template&id=1465c058"
import script from "./regulDbUploadHistory.vue?vue&type=script&lang=js"
export * from "./regulDbUploadHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1465c058')) {
      api.createRecord('1465c058', component.options)
    } else {
      api.reload('1465c058', component.options)
    }
    module.hot.accept("./regulDbUploadHistory.vue?vue&type=template&id=1465c058", function () {
      api.rerender('1465c058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/db/regulDbUploadHistory.vue"
export default component.exports